import { render } from "./View.vue?vue&type=template&id=1ce542dc&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./View.vue?vue&type=style&index=1&id=1ce542dc&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce542dc"]])

export default __exports__